import { render } from "./BookCom.vue?vue&type=template&id=11fadf02&scoped=true"
import script from "./BookCom.vue?vue&type=script&lang=js"
export * from "./BookCom.vue?vue&type=script&lang=js"

import "./BookCom.vue?vue&type=style&index=0&id=11fadf02&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11fadf02"]])

export default __exports__